// extracted by mini-css-extract-plugin
export default {"center":"cloud_center__wY6s+","cloud":"cloud_cloud__2bmd8","move":"cloud_move__ioKyD"};